export const filterPathError = [
  '/api/v1/platform/asset_order/behavior/get_show_msg_cache',
]
